import React from 'react';
import { TreeEntry, TreePath } from './types';
import { TreeItem } from './TreeItem';
import { tree_list_css } from './styles';

export interface TreeListProps {
  items: TreeEntry[];
  path: TreePath;
  role?: 'group' | 'tree';
}

export const TreeList: React.FC<TreeListProps> = ({ items, path, role = 'group' }) => {
  return (
    <ul css={tree_list_css} role={role}>
      {items.map((item, index) => (
        <TreeItem item={item} path={path} key={item.id} index={index} siblingCount={items.length}>
          {item.children != null && item.children.length > 0 && (
            <TreeList items={item.children} path={[...path, item]} />
          )}
        </TreeItem>
      ))}
    </ul>
  );
};
